import { Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { MenuOption } from '../models/menu-option';

@Component({
    selector: 'lib-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent implements OnInit {
  options = input<Array<MenuOption> | null>(null);
  label = input<string | null>(null)
  @Input() isOpen?: boolean = false;
  @Input() defaultOption?: MenuOption;
  @Input() dividerIndex?: number = null;
  @Input() disabled?: boolean = false;
  @Input() fullWidth?: boolean = false;
  @Input() isInvalid?: boolean = false;
  @Input() selectedOption: MenuOption = this.defaultOption;
  @Input() trackingIdPrefix?: string;

  @Output() optionSelected = new EventEmitter<MenuOption>();

  showMenu: boolean = false;

  constructor() {}

  ngOnInit() {
    this.showMenu = this.isOpen;
  }

  setShowMenu(showMenu: boolean) {
    if (!this.disabled) {
      this.showMenu = showMenu;
    }
  }

  selectOption(option: MenuOption) {
    this.selectedOption = option;
    this.showMenu = false;

    this.optionSelected.emit(this.selectedOption);
  }
}
